module.exports = __webpack_public_path__ + "static/media/visual-aid-page-1.8c294213.jpg";